import Repository from "@/repository";

export default {
  namespaced: true,

  state: {
    department: null,
    workDays: [],
  },

  actions: {
    async fetchDepartment({ commit }) {
      const { value, error } = await Repository.Departments.get();
      if (!error && value) {
        commit("setDepartment", value);
      }
    },

    async fetchWorkDays({ commit }) {
      const { value, error } = await Repository.Departments.getWorkDays();
      if (!error && value) {
        commit("setWorkDays", value);
      }
    },
  },

  mutations: {
    setDepartment(state, value) {
      state.department = value;
    },
    setWorkDays(state, value) {
      state.workDays = value;
    },
  },
};
